import LegajoView from '../LegajoView.vue'
import LegajoDashboard from '../Pages/LegajoDashboard.vue'
import EmployeeLegajo from '../Pages/EmployeeLegajo.vue'

// CDEF012: tablero de control y expediente de cada colaborador.
const routes = [
  {
    path: '/legajo',
    component: LegajoView,
    children: [
      { path: '', name: 'legajo-dashboard', component: LegajoDashboard },
      { path: 'colaborador/:id', name: 'legajo-employee', component: EmployeeLegajo },
    ],
  },
]

export default routes
